import * as React from 'react'

import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

import { cn } from '@/lib/ui/style-helpers'

import { Badge } from '@/components/lemmala-design-system/badge/badge'
import { RISK_LEVEL_MAP } from '@/components/shared/risk-badge/consts'

import { SeverityCountStat } from './types'

export interface SeverityCountProps extends React.HTMLAttributes<HTMLDivElement> {
  countStat: SeverityCountStat
}

export const SeverityCount = React.forwardRef<HTMLDivElement, SeverityCountProps>(
  ({ className, countStat, ...props }, ref) => {
    const { count, riskLevel } = countStat

    if (count <= 0 || riskLevel === RiskLevel.UNSPECIFIED) {
      return null
    }

    const levelConfig = RISK_LEVEL_MAP[riskLevel]
    if (!levelConfig) {
      return null
    }

    const { variant, text } = levelConfig

    return (
      <div
        ref={ref}
        data-testid='severity-count'
        className={cn('inline-flex items-center gap-1', className)}
        {...props}
      >
        <span className='text-main-foreground-primary text-body-default'>{count}</span>
        <Badge variant={variant} badgeStyle='subtle' size='default'>
          {text}
        </Badge>
      </div>
    )
  },
)
SeverityCount.displayName = 'SeverityCount'
